import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { toggleFavorite } from '../../../actions/favorite';
import { selectIsFavorite } from '../../../selectors/favorite';
import { TThunkDispatch } from '../../../types/redux';

interface IFavoriteButton {
  isFavorite: boolean;
  handleClickFavorite(): void;
}

export const useFavoriteButton = (): IFavoriteButton => {
  const isFavorite = useSelector(selectIsFavorite);
  const dispatch: TThunkDispatch = useDispatch();

  const handleClickFavorite = React.useCallback(() => {
    dispatch(toggleFavorite());
  }, [dispatch]);

  return {
    isFavorite,
    handleClickFavorite,
  };
};
